export const BaseResources = {
  USERS: "USERS",
  ROBOTS: "ROBOTS",
  ADMINS: "ADMINS",
  TASKS: "TASKS",
  CLIENTS: "CLIENTS",
} as const;

export type BaseResourceType = typeof BaseResources[keyof typeof BaseResources];